import React, { useContext, useState } from 'react';

import { media } from 'context';
import Clickable from 'ds/Clickable';
import Icon from 'ds/Icon';
import Layout from 'ds/Layout';
import Text from 'ds/Text';

import FeedbackModal from './FeedbackModal';

interface Props {
  liked?: boolean | null;
  disabled?: boolean;
  handleFeedback: (params: { liked: boolean; message?: string }) => void;
  onVisibleChange?: (visible: boolean) => void;
  includeModal?: boolean;
}

const FeedbackThumbControls: React.FC<Props> = ({
  liked,
  handleFeedback,
  onVisibleChange,
  includeModal = true,
  ...props
}) => {
  const notLiked = liked === false;
  const { xs } = useContext(media);
  // @ts-expect-error
  const disabled = [true, false].includes(liked) || props.disabled;
  const [isModalVisible, setModalIsVisible] = useState(false);
  const [modalLiked, setModalLiked] = useState<boolean | null>(null);

  const onClose = () => {
    setModalIsVisible(false);
    onVisibleChange?.(false);
  };

  return (
    <>
      {includeModal && (
        <FeedbackModal
          isVisible={isModalVisible}
          onClose={onClose}
          handleSubmit={handleFeedback}
          liked={modalLiked}
          prompt={<Text size={xs ? 'headline-sm' : 'headline-md'}>How was your support request experience?</Text>}
          likedConfig={{
            doneText: 'Thanks for your feedback!',
            promptText: 'Tell us why you liked our service'
          }}
          notLikedConfig={{
            doneText:
              "We're looking into your issue and will be in touch. Thanks for sharing. Your feedback helps us improve our services.",
            promptText: 'Tell us how we can improve our service *'
          }}
        />
      )}
      <Layout align="center">
        <Clickable
          {...(disabled
            ? { color: liked === true ? 'blue-500' : 'gray-25' }
            : {
                color: 'gray-25',
                hoverColor: 'gray-50'
              })}
          style={{
            borderRadius: '50%',
            width: 28,
            height: 28,
            justifyContent: 'center',
            alignItems: 'center',
            display: 'inline-flex'
          }}
          onClick={event => {
            if (disabled) return;
            event.preventDefault();
            event.stopPropagation();

            if (includeModal) {
              setModalLiked(true);
              setModalIsVisible(true);
              onVisibleChange?.(true);
            } else {
              handleFeedback({ liked: true });
            }
          }}
          context="thumbsUp-Feedback"
        >
          <Icon
            name={liked ? 'thumbsUpFilled' : 'thumbsUp'}
            stroke={liked ? 1.5 : 2}
            color={liked ? 'white' : 'gray-400'}
            size={16}
          />
        </Clickable>
        <Clickable
          {...(disabled
            ? { color: notLiked ? 'blue-500' : 'gray-25' }
            : {
                color: 'gray-25',
                hoverColor: 'gray-50'
              })}
          style={{
            borderRadius: '50%',
            width: 28,
            height: 28,
            justifyContent: 'center',
            alignItems: 'center',
            display: 'inline-flex'
          }}
          onClick={event => {
            if (disabled) return;
            event.preventDefault();
            event.stopPropagation();
            if (includeModal) {
              setModalLiked(false);
              setModalIsVisible(true);
              onVisibleChange?.(true);
            } else {
              handleFeedback({ liked: false });
            }
          }}
          context="thumbsDown-Feedback"
        >
          <Icon
            name={notLiked ? 'thumbsDownFilled' : 'thumbsDown'}
            stroke={notLiked ? 1.5 : 2}
            color={notLiked ? 'white' : 'gray-400'}
            size={16}
          />
        </Clickable>
      </Layout>
    </>
  );
};

export default FeedbackThumbControls;
